"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tooltip = _interopRequireDefault(require("../../atoms/tooltip"));

var _text = _interopRequireDefault(require("../../atoms/text"));

var _button = _interopRequireDefault(require("../../atoms/button"));

var _fontIcon = _interopRequireDefault(require("../../atoms/font-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  &:hover {\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding-right: 10px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CopyText = (0, _styledComponents["default"])(_text["default"])(_templateObject());
var CopyButton = (0, _styledComponents["default"])(_button["default"])(_templateObject2());

var CopyToClipboard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CopyToClipboard, _React$Component);

  function CopyToClipboard(props) {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CopyToClipboard).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "copyToClipboard", function () {
      var copyText = document.createElement('textarea');
      copyText.innerText = _this.props.children;
      document.body.appendChild(copyText);
      copyText.select();
      document.execCommand('copy');
      copyText.remove();

      _this.setState({
        copied: true
      });

      setTimeout(function () {
        return _this.setState({
          copied: false
        });
      }, 2000);
    });

    _this.state = {
      copied: false
    };
    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          messageBeforeCopy = _this$props.messageBeforeCopy,
          messageAfterCopy = _this$props.messageAfterCopy,
          position = _this$props.position;
      var tooltipContent = this.state.copied ? messageAfterCopy : messageBeforeCopy;
      return _react["default"].createElement("span", null, _react["default"].createElement(CopyText, {
        size: 5
      }, children), _react["default"].createElement(_tooltip["default"], {
        position: position,
        content: tooltipContent
      }, _react["default"].createElement(CopyButton, {
        view: "plain",
        size: "small",
        onClick: this.copyToClipboard
      }, _react["default"].createElement(_fontIcon["default"], null, "icon-copy"))));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].Component);

CopyToClipboard.propTypes = {
  /** Text to be copied. */
  children: _propTypes["default"].string,
  messageBeforeCopy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  messageAfterCopy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  position: _propTypes["default"].oneOf(['top', 'bottom'])
};
CopyToClipboard.defaultProps = {
  messageBeforeCopy: 'Copy',
  messageAfterCopy: 'Copied',
  position: 'bottom'
};
var _default = CopyToClipboard;
exports["default"] = _default;